module.exports = "<p>\r\n  configuracoes works!\r\n</p>\r\n"